// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1D7L4","leftSide":"_3shVL","heading":"_3z-IQ","subHeading":"_3rHxg","valuationWrapper":"_3dwDJ"};